const initMenu = () => {
    const menuToggle = document.querySelector('.menu-js-toggle')
    const menu = document.querySelector('.menu-js')

    menuToggle.addEventListener("click", () => {
        menuToggle.classList.toggle("opened")
        menu.classList.toggle("opened")
    })
}

export { initMenu }